import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, interval } from 'rxjs';
import { debounce } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services';
import { TableBtn } from 'src/app/shared/interfaces/table-btn';

@Component({
  selector: 'telio-dynamic-table',
  templateUrl: './dynamic-table.component.html',
  styleUrls: ['./dynamic-table.component.scss']
})
export class DynamicTableComponent implements OnInit, OnChanges {

  @Input() tableColumns: any = [];
  @Input() tableData: any = [];
  @Input() totalDataCount: any;
  @Input() globalSearch: any;
  @Input() currentPage: number;
  @Input() pageSize: number = 50;
  @Input() columnFilter: any;
  @Input() exportButton = false;
  @Input() showPaginator: any;
  @Input() defaultColumn: Array<string> = [];
  @Input() tableDetails: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  dataSource: MatTableDataSource<any>;
  @Input() paginationSizes: number[] = [10, 25, 50, 100];
  displayedColumns: Array<string> = [];
  multiselectColumnFilter: any = [];
  @Output() actionExportCSV = new EventEmitter<any>();
  @Output() loadData = new EventEmitter<any>();
  @Output() actionReloadData = new EventEmitter<any>();
  @Input() reloadFlag = false;
  customTableForm!: FormGroup;
  change: any;
  @Output() sortClick = new EventEmitter<any>();
  @Output() linkClick = new EventEmitter<any>();
  @ViewChild('selectDropDown') selectDropDown: MatSelect;
  @Output() savePreference = new EventEmitter<any>();
  isFirstChange = true;
  initialTableColumns: any[] = [];
  updatedTableCoulmns: any[] = [];
  selectedColumns: string[] = [];
  @Input() filter: boolean = false;
  @Input() filterPlaceholder: string = 'Filter';
  @Output() filteredData = new EventEmitter<any>();
  obs: Subscription;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Output() actionCSV = new EventEmitter();
  @Input() actionCSVFlag = false;
  @ViewChild('selectDropdown') selectDropdown!: MatSelect;
  menuOpened = false;
  form = new UntypedFormGroup({
    searchFilter: new UntypedFormControl(''),
  });
  reloadLabel: string = '';
  downloadCSVLabel: string = '';
  columnFilterLabel: string = ''
  @Output() actionClick = new EventEmitter();
  @Input() actionReload = false;
  @Input() actionFeatureLabel: string = '';
  @Input() actionFeatureFlag = false;
  @Output() actionFeature = new EventEmitter();
  @Input() buttons: TableBtn[] = [];
  @Input() actionHeader: string = null;
  @Output() buttonClick = new EventEmitter<string[]>();
  rs;

  constructor(private formBuilder: FormBuilder, private cdRef: ChangeDetectorRef,readonly translate: TranslateService,
    private authenticationService: AuthenticationService,) {
    this.reloadLabel = 'generalTable.reload';
    this.downloadCSVLabel = 'generalTable.downloadCSV';
    this.columnFilterLabel = 'generalTable.columnFilterLabel'
    this.translate.onLangChange.subscribe(() => {
      this.translateLabels();
    });
    let localInfo = this.authenticationService.getlocalInfo.subscribe(local => {
      this.rs = local ? local.currency_symbol : this.translate.instant('rs');
      this.rs = '(' + this.rs + ')'
    });
   }

  ngOnInit(): void {
      this.customTableForm = this.formBuilder.group({
        multiselectColumn: ['']
      });
      this.customTableForm.patchValue({
        multiselectColumn: this.defaultColumn
      });
      this.obs = this.form.valueChanges
      .pipe(debounce(() => interval(1000)))
      .subscribe(data => this.applyFilter(data.searchFilter));
      setTimeout(() => {
        this.refreshData();
      }, 300);
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  private refreshData() {
    this.dataSource = new MatTableDataSource(this.tableData);
    if (!!this.defaultColumn && !!this.customTableForm && !!this.customTableForm.patchValue) {
      this.customTableForm.patchValue({
        multiselectColumn: this.defaultColumn
      });
    }
    this.defaultColumn = [...this.displayedColumns];
    setTimeout(() => {
      if (this.paginator) {
        this.paginator.pageIndex = this.currentPage;
        this.paginator.length = this.totalDataCount;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.tableData) {
      const selectedOptions = this.tableColumns
        .filter(column => !column.hidden)
        .map(column => column.dataIndex);
      this.customTableForm.controls['multiselectColumn'].setValue(selectedOptions)
      if (changes.tableData) {
        if (this.isFirstChange) {
          this.initialTableColumns = [...this.tableColumns];
          this.isFirstChange = false;
        }
        if (!!changes['defaultColumn']) {
          this.change = changes['defaultColumn'];
          this.multiselectColumnFilter = changes['tableColumns'].currentValue;
        }
        if (!this.columnFilter) {
          if (this.displayedColumns.length > 0) {
            this.tableColumns = this.tableColumns.filter((x: any) => this.displayedColumns.includes(x.dataIndex));
        } else {
            this.tableColumns = this.tableColumns.filter((x: any) => !x.hidden);
        }
        this.displayedColumns = !!this.tableColumns && this.tableColumns.map((c: any) => c.dataIndex);
        } else {
          if (!!this.tableData) {
            this.displayedColumns = this.change.currentValue;
            this.tableColumns = this.tableColumns.filter((x: any) => this.displayedColumns.includes(x.dataIndex));
          } else {
            this.tableColumns = this.tableColumns.filter((x: any) => this.defaultColumn.includes(x.dataIndex));
            this.displayedColumns = !!this.tableColumns && this.tableColumns.map((c: any) => c.dataIndex);
          }
        }
         if (this.buttons.length > 0)  this.displayedColumns = [...this.displayedColumns, 'actions'];
        this.refreshData();
      }
    }

  }

  pageChanged(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    const selectedColumns = this.customTableForm.get('multiselectColumn').value;
    const pagination = {
      currentPage: this.pageSize * event.pageIndex,
      pageSize: this.pageSize,
      selectedColumns: selectedColumns
    };

    this.loadData.emit(pagination);
    this.resetScrollbarToTop();
  }
  resetScrollbarToTop() {
    const table = document.getElementById("matGeneralTable");//replace with dynamic table
    if (table) {
      const tableBody = (<HTMLTableElement>table).tBodies;
      if (tableBody && tableBody.length > 0) {
        tableBody[0].scrollTop = 0;
      }
    }
  }

  sortData(event) {
    this.sortClick.emit(event);
  }

  onSelectColumn(event) {
    this.defaultColumn = event.value;
    this.tableColumns = this.multiselectColumnFilter.filter((x: any) => this.defaultColumn.includes(x.dataIndex));
    this.displayedColumns = !!this.tableColumns && this.tableColumns.map((c: any) => c.dataIndex);
    if (this.buttons.length > 0)  this.displayedColumns = [...this.displayedColumns, 'actions'];
    this.tableColumns.forEach(obj => obj.hidden = false);
  }

  openDropDown() {
    this.selectDropDown.open();
  }

  onMenuClosed() {
    this.menuOpened = false;
  }

  openSelect() {
    this.menuOpened = true;
    this.selectDropdown.open();
  }

  savePreferences() {
    this.initialTableColumns.forEach(obj=> obj.mandatory ? obj.hidden = false : obj.hidden = obj.hidden);
    this.updatedTableCoulmns = this.updateHidden(this.initialTableColumns,this.tableColumns);
    this.savePreference.emit(this.updatedTableCoulmns);
  }

  updateHidden(arrayA, arrayB) {
    return arrayA.map(itemA => {
      const matchingItemB = arrayB.find(itemB => itemB.dataIndex === itemA.dataIndex);
      return {
        ...itemA,
        hidden: matchingItemB ? false : true
      };
    });
  }

  applyFilter(filterValue: string) {
    this.filterPortion(filterValue);
  }

  filterPortion(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.filteredData.emit(filterValue);
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }

    this.dataSource.sort = this.sort;
    if (this.dataSource.filteredData.length == 0) {
      this.totalDataCount = 0;
    }
  }
  
  getDataCheck(data: any) {
    return (this.dataSource.filteredData.length === 0 && data != '')
  }

  translateLabels() {
    this.dataSource.paginator = this.paginator;
    this.paginator._intl.itemsPerPageLabel = this.translate.instant('generalTable.perPage');
    this.paginator._intl.nextPageLabel = this.translate.instant('generalTable.nextPage');
    this.paginator._intl.previousPageLabel = this.translate.instant('generalTable.previousPage');
    this.paginator._intl.firstPageLabel = this.translate.instant('generalTable.firstPage');
    this.paginator._intl.lastPageLabel = this.translate.instant('generalTable.lastPage');
  }

  reload() {
    const currentFilterValue = this.form.get('searchFilter').value;
    if (currentFilterValue) {
      this.form.get('searchFilter').setValue('');
    } else {
      this.actionClick.emit();
    }
  }

  link(col, ele) {
    this.linkClick.emit(ele);
  }

}